class MarloweContactForm {
  constructor(form) {
    this.form = form;
    this.button = form.querySelector('button[type="submit"]');
    this.status = form.querySelector('[data-marlowe-contact-status]');
    this.email = form.querySelector('input[type="email"]');
    this.submittedAt = form.querySelector('[data-marlowe-submitted-at]');
    this.defaultLabel = this.button?.textContent.trim() || 'Send Inquiry';
    this.form.addEventListener('submit', (event) => this.submit(event));
  }

  submit(event) {
    if (!this.form.reportValidity()) {
      event.preventDefault();
      return;
    }

    const emailValue = this.email?.value.trim() || '';
    if (!this.isValidEmail(emailValue)) {
      event.preventDefault();
      this.setState('error', 'Please enter a valid email address.');
      this.email?.focus();
      return;
    }

    if (this.submittedAt) {
      this.submittedAt.value = new Date().toLocaleString('en-US', {
        dateStyle: 'medium',
        timeStyle: 'short',
        timeZoneName: 'short',
      });
    }

    this.setState('sending', 'Sending...');
  }

  isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  setState(state, message) {
    const sending = state === 'sending';
    if (this.button) {
      this.button.disabled = sending;
      this.button.textContent = sending ? 'Sending' : this.defaultLabel;
    }
    if (this.status) {
      this.status.textContent = message;
      this.status.dataset.state = state;
    }
  }
}

document.querySelectorAll('[data-marlowe-contact]').forEach((form) => {
  if (!form.dataset.initialized) {
    form.dataset.initialized = 'true';
    new MarloweContactForm(form);
  }
});
